import { I18n } from '@calendly/i18n'
import { TitleText } from '@calendly/ui/components/typography'
import { useSelector } from 'react-redux'

import { featuresSelector } from 'features/admin/selectors'
import { getPastTimes, REPORT_STATUS, useFetchMeetingsReport, useFetchCancelledMeetingsReport } from 'features/reporting'
import { timezoneSelector, isAdminOrOwnerSelector } from 'selectors/current_user'


import { AnalyticsTile } from './analytics_tile'
import { Trend } from './components'
import { Tile } from '../../components/tile'


export const EventData = () => {
  const timezone = useSelector(timezoneSelector)
  const { end, start } = getPastTimes(timezone, 7)
  const features = useSelector(featuresSelector)
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector)

  if (!features.includes('admin_dashboard') || !isOwnerOrAdmin) {
    return (
      <>
        <Tile
          componentName="booked-events"
          icon={<TitleText as="div" level={3} size="large">0</TitleText>}
          name={I18n.t('publisher.organization.reporting.titles.total_booked_events')}
          controls={<Trend currentCount={0} pastCount={0} />}
        />
        <Tile
          componentName="occurred-events"
          icon={<TitleText as="div" level={3} size="large">0</TitleText>}
          name={I18n.t('publisher.organization.reporting.titles.total_occurred_events')}
          controls={<Trend currentCount={0} pastCount={0} />}
        />
        <Tile
          componentName="cancelled-events"
          icon={<TitleText as="div" level={3} size="large">0</TitleText>}
          name={I18n.t('publisher.organization.reporting.titles.total_cancelled_events')}
          controls={<Trend currentCount={0} pastCount={0} />}
        />
      </>
    )
  }

  return (
    <>
      <AnalyticsTile
        componentName="booked-events"
        end={end}
        fetchMeetings={useFetchMeetingsReport}
        name={I18n.t('publisher.organization.reporting.titles.total_booked_events')}
        start={start}
        status={REPORT_STATUS.BOOKED}
        timezone={timezone}
      />
      <AnalyticsTile
        componentName="occurred-events"
        end={end}
        fetchMeetings={useFetchMeetingsReport}
        name={I18n.t('publisher.organization.reporting.titles.total_occurred_events')}
        start={start}
        status={REPORT_STATUS.OCCURRED}
        timezone={timezone}
      />
      <AnalyticsTile
        componentName="cancelled-events"
        end={end}
        fetchMeetings={useFetchCancelledMeetingsReport}
        name={I18n.t('publisher.organization.reporting.titles.total_cancelled_events')}
        start={start}
        status={REPORT_STATUS.CANCELLED}
        timezone={timezone}
      />
    </>
  )
}
